import { FC } from 'react';
import { Box, } from '@mui/material';
import { CircularProgress } from "@mui/material";

interface LoaderProps {
    isOpen: boolean,
    isInline: boolean,
    size?: number
}

const LoaderStyles = {
    inlineLoader: {
        display: "flex",
        justifyContent: "center",
        padding: "20px"
    } as const,
    generalLoader: {
        position: "absolute",
        top: "50%",
        left: "50%"
    } as const
};

const Loader: FC<LoaderProps> = (props) => {

    return (
        props.isOpen &&
        <Box sx={props.isInline ? LoaderStyles.inlineLoader : LoaderStyles.generalLoader}>
            <CircularProgress size={props.size} />
        </Box>

    );
};

export default Loader;
